<button type="button" class="close-button" (click)="close()">
    <img class="icon-close" aria-label="Close" src="sb-tools/theme/images/Svg icons WEB/Web icons/X icon.svg" />
</button>
<div class="p-3">
    <p>
        <strong>
            {{ 'What is "Right of Access"?' | translate }}
        </strong>
    </p>
    <p translate>
        According to the new GDPR regulations, which is applicable within EU/EOS from May 25, 2018, individuals have the
        rights to access their personal data and supplementary information.
    </p>
    <br />
    <p>
        <strong>
            {{ 'What can I do on this page?' | translate }}
        </strong>
    </p>
    <p>
        <span translate>
            On this page you can use your "Right of Access" to receive all information that Socialboards as a data
            processor has collected on behalf of
        </span>
        {{ communityDisplayName }}
    </p>
    <br />
    <p>
        <strong>
            {{ 'About Socialboards' | translate }}
        </strong>
    </p>
    <p translate>
        Socialboards AS is a Norwegian company that provides web-based solutions for efficient customer dialogue in
        social- and digital media channels.
    </p>
    <br />
    <p>
        <strong> {{ 'Our relationship with' | translate }} {{ communityDisplayName }} </strong>
    </p>
    <p>
        {{ 'Socialboards AS is being used for support purposes in Social Media by' | translate }}
        {{ communityDisplayName }}{{ ', to improve your customer service experience.' | translate }}
    </p>
</div>
